import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeDuration',
    standalone: false
})
export class TimeDurationPipe implements PipeTransform {
  transform(value: number): string {
    const hours = Math.floor(value / 3600);

    //once a duration runs into hours the seconds stop telling anyone anything
    if (hours > 0) {
      const remainingMinutes = Math.floor((value % 3600) / 60);

      if (remainingMinutes === 0) return `${hours}h`;
      return `${hours}h ${remainingMinutes < 10 ? '0' + remainingMinutes : remainingMinutes}m`;
    }

    const minutes = Math.floor(value / 60);
    const seconds = Math.round(value % 60);

    if (seconds === 0) return `${minutes}m`;
    return `${minutes}m ${seconds < 10 ? '0' + seconds : seconds}s`;
  }
}
